import React from 'react';

// Accordion of [question, answer] pairs; the first one starts open.
export default function Faq({ items, accent = 'text-brand', divide = 'divide-slate-200 border-slate-200' }) {
  return (
    <div className={`divide-y border-y ${divide}`}>
      {items.map(([q, a], i) => (
        <details key={q} open={i === 0} className="py-5">
          <summary className="flex justify-between items-center gap-4 cursor-pointer font-semibold text-lg">
            {q}<span className={`plus text-2xl transition-transform ${accent}`} aria-hidden="true">+</span>
          </summary>
          <p className="mt-3 text-slate-600 leading-relaxed">{a}</p>
        </details>
      ))}
    </div>
  );
}
